export function OutlineScissorsIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7122 12.4315L12.4178 15.6285C12.5186 16.099 12.8066 16.5118 13.2147 16.771L17.3813 19.4304C18.7062 20.2752 20.4679 19.8864 21.3128 18.5615L11.7122 12.4315ZM11.7122 12.4315L7.93433 7.76562"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42064 8.57199L4.15643 6.48866C3.30677 5.94622 3.05716 4.81815 3.59959 3.97329L3.6812 3.84368C4.22363 2.99403 5.35171 2.74441 6.19656 3.28685L7.92467 4.39092C8.77433 4.93336 9.02394 6.06143 8.48151 6.90628L7.42064 8.57199Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7122 12.4315L12.4178 15.6285C12.5186 16.099 12.8066 16.5118 13.2147 16.771L17.3813 19.4304C18.7062 20.2752 20.4679 19.8864 21.3128 18.5615L11.7122 12.4315ZM11.7122 12.4315L7.93433 7.76562"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.42064 8.57199L4.15643 6.48866C3.30677 5.94622 3.05716 4.81815 3.59959 3.97329L3.6812 3.84368C4.22363 2.99403 5.35171 2.74441 6.19656 3.28685L7.92467 4.39092C8.77433 4.93336 9.02394 6.06143 8.48151 6.90628L7.42064 8.57199Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6882 10.8478L12.4658 6.89719L17.1941 3.71938V3.71458C18.4998 2.84093 20.2663 3.18655 21.1448 4.49224L11.6882 10.8478ZM11.6882 10.8478L8.02075 15.6002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49268 14.8125L4.27647 16.9726C3.44122 17.5343 3.22041 18.6672 3.78204 19.5024L3.86845 19.6272C4.43008 20.4625 5.56296 20.6833 6.39821 20.1216L8.10232 18.9792C8.93758 18.4175 9.15839 17.2847 8.59676 16.4494L7.49748 14.8125H7.49268Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6928 10.8478L12.3217 7.63644C12.4177 7.16121 12.6913 6.74358 13.0945 6.47476L17.194 3.71938L17.1988 3.71458C18.5045 2.84093 20.271 3.18655 21.1494 4.49224L11.6928 10.8478ZM11.6928 10.8478L8.02539 15.6002"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.49268 14.8125L4.27647 16.9726C3.44122 17.5343 3.22041 18.6672 3.78204 19.5024L3.86845 19.6272C4.43008 20.4625 5.56296 20.6833 6.39821 20.1216L8.10232 18.9792C8.93758 18.4175 9.15839 17.2847 8.59676 16.4494L7.49748 14.8125H7.49268Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
